import PageMeta from '../components/seo/PageMeta';
import { HomeStructuredData } from '../components/seo/StructuredData';
import QrGenerator from '../components/qr/QrGenerator';
import AdUnit from '../components/ads/AdUnit';
import BenefitsSection from '../components/home/BenefitsSection';
import HowItWorksSection from '../components/home/HowItWorksSection';
import SeoContentSection from '../components/home/SeoContentSection';
import FaqSection from '../components/home/FaqSection';
import SupportSection from '../components/home/SupportSection';
import { DEFAULT_META } from '../constants';

export default function HomePage() {
  return (
    <>
      <PageMeta
        title={DEFAULT_META.title}
        description={DEFAULT_META.description}
        path="/"
      />
      <HomeStructuredData />
      <QrGenerator />
      <section
        className="border-y border-slate-100 bg-slate-50/60 py-6"
        aria-label="Advertisement"
      >
        <div className="mx-auto flex max-w-3xl justify-center px-4 sm:px-6">
          <AdUnit
            slot="2433836650"
            format="horizontal"
            className="w-full min-h-[90px] overflow-hidden rounded-lg"
          />
        </div>
      </section>
      <BenefitsSection />
      <HowItWorksSection />
      <SeoContentSection />
      <FaqSection />
      <SupportSection />
    </>
  );
}
